import React, { FCC } from 'react'

import { Navbar } from '@sketch/components'

import HeaderNavigation from '../../../components/HeaderNavigation'
import { BackButtonLink } from '../../../components/BackButton'
import { ShareWithoutVersion, useVersioning } from '../../../../versioning'
import { HeaderNavigationSectionInfo } from '../../../components/HeaderNavigation/types'

import {
  BackButtonItem,
  EmbeddedHeaderSection,
} from './SectionDetailHeader.styles'

type SectionDetailHeaderEmbeddedProps = {
  share: ShareWithoutVersion
  sectionInfo: HeaderNavigationSectionInfo
}

/**
 * The header a Section shows inside an embed.
 *
 * An embed shows the document, not the tools for working on it, which is why
 * the page and frame views both swap their header for a smaller one here. The
 * Section view had no embedded header at all, so it kept the full one - and
 * with it Versions, Inspect and Comments, which an embed has nowhere to put.
 *
 * What is left is what you can act on without leaving the frame it is in: the
 * Section you are looking at, the ones beside it, and the way back out to the
 * document. The arrow is spelled out rather than left to the layout's
 * contextual one, which a Section route never gets: the navigation stack has
 * no level for a Section, so it reads as the document view it came from and
 * finds nothing to go back to.
 */
export const SectionDetailHeaderEmbedded: FCC<
  SectionDetailHeaderEmbeddedProps
> = ({ share, sectionInfo }) => {
  const { getPathname } = useVersioning()

  const sharePath = getPathname({
    routeKey: 'SHARE_VIEW',
    routeParams: { shareID: share.identifier },
  })

  return (
    <Navbar isDocumentView>
      <EmbeddedHeaderSection>
        <BackButtonItem>
          <BackButtonLink content="Back to Document" link={sharePath} />
        </BackButtonItem>

        <HeaderNavigation share={share} sectionInfo={sectionInfo} />
      </EmbeddedHeaderSection>
    </Navbar>
  )
}
